import { Form } from "antd"
import { Group, SelectInput } from "components/common"
import { t } from "i18next"
import PaymentProofImageUpload from "../../paymentProofImageUpload"

const AccountantSection = ({ form, accountantData, isLoadingAccountant, platformKey, projectId }) => (
  <Group template="repeat(2, 1fr)" gap="6px 32px">
    <Form.Item
      name="regional_accountant"
      label={t("Accountant")}
      required
      rules={[{ validator: (_, value) => (!value ? Promise.reject(t("Accountant is Required")) : Promise.resolve()) }]}
    >
      <SelectInput placeholder={t("Choose Accountant")} options={accountantData} inputLoading={isLoadingAccountant} />
    </Form.Item>
    <Form.Item name="accountantReceipt" label={t("Receipt")}>
      <PaymentProofImageUpload
        setFiles={data => form.setFieldsValue({ accountantReceipt: data })}
        platformKey={platformKey}
        projectId={projectId}
        paymentProofProps={{
          attachmentTypeId: 1,
        }}
      />
    </Form.Item>
  </Group>
)

export default AccountantSection
